import { useState } from "react";
import { Card, CardContent } from "../ui/card";
import type { TrackEvent } from "@/types/generated";
import { Button } from "../ui/button";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { router } from "@inertiajs/react";

interface GenerateCommentaryCardProps {
  trackEvent: TrackEvent;
}

export function GenerateCommentaryCard({
  trackEvent,
}: GenerateCommentaryCardProps) {
  const [isGenerating, setIsGenerating] = useState(false);

  const shouldShow =
    !trackEvent.race_commentary &&
    (trackEvent.session_type === "race" ||
      trackEvent.session_type === "qualifying");
  if (!shouldShow) return null;

  async function handleGenerate() {
    setIsGenerating(true);
    try {
      const response = await fetch(
        `/event/${trackEvent.id}/generate_commentary`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token":
              document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
                ?.content || "",
          },
        }
      );
      const data = await response.json();
      if (data.success) {
        toast.success("Commentary generation started!", {
          description: "Refresh the page in a few seconds to see it.",
        });
        setTimeout(() => router.reload(), 3000);
      } else {
        toast.error("Error", { description: data.error });
      }
    } catch {
      toast.error("Error", {
        description: "Failed to generate commentary. Please try again.",
      });
    } finally {
      setIsGenerating(false);
    }
  }

  return (
    <Card className="mb-6">
      <CardContent className="pt-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium">Race Commentary</p>
            <Button onClick={handleGenerate} disabled={isGenerating}>
              {isGenerating ? (
                <>
                  <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                  Generating...
                </>
              ) : (
                <>Generate</>
              )}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
